// extracted by mini-css-extract-plugin
export var badge = "press-module--badge--62eac";
export var badgeImage = "press-module--badgeImage--be78d";
export var card = "press-module--card--8e338";
export var cardContent = "press-module--cardContent--f37b9";
export var cardHeadline = "press-module--cardHeadline--04bc6";
export var cardImage = "press-module--cardImage--c584a";
export var cardImageWrapper = "press-module--cardImageWrapper--db981";
export var cardLink = "press-module--cardLink--7096b";
export var cardMeta = "press-module--cardMeta--41602";
export var carouselWrapper = "press-module--carouselWrapper--0e862";
export var controls = "press-module--controls--6bde2";
export var header = "press-module--header--525ef";
export var logo = "press-module--logo--a5cee";
export var logoCard = "press-module--logoCard--fac11";
export var navButton = "press-module--navButton--5272f";
export var pagination = "press-module--pagination--409fc";
export var pressLink = "press-module--pressLink--ad6d9";
export var slide = "press-module--slide--532b8";
export var swiper = "press-module--swiper--c45b6";